import { openURL } from "expo-linking";
import { PlayerContextState } from "../backend/PlayerContext";
import { serializeSaveData } from "../backend/SaveData";

export type LoadResult =
  | {
      result: "success";
      data: PlayerContextState;
    }
  | {
      result: "cancel";
    }
  | {
      result: "error";
      error: string;
    };

export type SaveResult =
  | {
      result: "success";
    }
  | {
      result: "cancel";
    }
  | {
      result: "error";
      error: string;
    };

export const SAVE_TO_FILE_SUPPORTED = true;
export const LOAD_FROM_FILE_SUPPORTED = false;

export async function loadSaveFromFile(): Promise<LoadResult> {
  return { result: "error", error: "Not implemented" };
}

export async function saveToFile(
  state: PlayerContextState,
): Promise<SaveResult> {
  const serializedData = await serializeSaveData(state);
  await openURL("data:application/octet-stream;utf8," + serializedData);
  return { result: "success" };
}
